import { validateFrontendConfiguration } from "../../model/config/FrontendConfiguration.js";

/**
 * Returns the frontend configuration.
 */
export const getFrontendConfiguration = () => {
  return validateFrontendConfiguration((window as any).configuration);
};
